import { render } from "./StudentHome.vue?vue&type=template&id=21a95158&scoped=true"
import script from "./StudentHome.vue?vue&type=script&lang=js"
export * from "./StudentHome.vue?vue&type=script&lang=js"

import "./StudentHome.vue?vue&type=style&index=0&id=21a95158&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s574086\\textbook-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a95158"]])

export default __exports__